import { Component } from '@angular/core';

@Component({
    selector: 'rk-setting-divider',
    templateUrl: './setting-divider.component.html',
    styleUrls: ['./setting-divider.component.scss'],
    standalone: false
})
export class SettingDividerComponent {

}
